import { defineMessages } from 'react-intl';

const messages = defineMessages({
  requiredFields: {
    id: 'App.Login.ResetPassword.RequiredFields',
    defaultMessage: 'Required'
  },
  invalid: {
    id: 'App.Login.ResetPassword.invalid',
    defaultMessage: 'Invalid Id'
  },
});

export default messages;
